import { Reducer } from "redux";
import { SET_RUNTIME_VARIABLE } from "../constants";

const runtime: Reducer<any, any> = (state = {}, action) => {
  switch (action.type) {
    case SET_RUNTIME_VARIABLE:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    default:
      return state;
  }
}
export default runtime
